export default __webpack_public_path__ + "static/bog_logo-81d2f533c4aa804c03e93d14e8773477.png";